import { ButtonHTMLAttributes, DetailedHTMLProps, FC, HTMLAttributes } from 'react'
import clsx from 'clsx'

export type ButtonVariant = 'outline' | 'fill' | 'text'
export type ButtonColor = 'primary' | 'secondary'
export type ButtonSize = 'sm' | 'md' | 'custom'

export interface BaseButtonProps
  extends Omit<
    DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
    'color' | 'size' | 'className'
  > {
  /**
   * Button's varaint
   * @defaultValue `ButtonVariant.outline`
   */
  variant?: ButtonVariant

  /**
   * Button's color variant
   * @defaultValue `ButtonColor
   */
  color?: ButtonColor

  /**
   * Button's size
   * @defaultValue `ButtonSize.md`
   */
  size?: ButtonSize

  /**
   * Indicates if uppercase text transform should be disabled
   * @defaultValue false
   */
  disableUppercaseTransform?: boolean

  /**
   * Custom css class names
   */
  className?: string
}

// .button-base {
//   @apply font-medium uppercase text-base outline-none
//   focus:outline-none shadow-none focus:shadow-none
//   border-none;
//   line-height: 1.25;
// }

// .size-sm {
//   @apply px-lg py-sm text-sm leading-5.5;
// }

// .size-md {
//   @apply px-xl py-md text-base leading-5.5 font-medium;
// }

// $colors: (
//   'primary': var(--midnight),
//   'secondary': var(--action),
// );

// /* Outline variant for each color generator */
// @each $color-key, $color-value in $colors {
//   .outline-#{$color-key} {
//     color: $color-value;
//     border: 1px solid $color-value;

//     &:hover {
//       background-color: var(--group-grey);
//     }
//   }

//   .text-#{$color-key} {
//     color: $color-value;
//   }
// }

// .fill-primary {
//   background-color: map-get($colors, 'primary');
//   color: var(--white);
// }

// .fill-secondary {
//   background-color: map-get($colors, 'secondary');
//   color: map-get($colors, 'primary');
// }

// /* Disables text transforming */
// .no-uppercase {
//   text-transform: none;
// }

/**
 * UI Button
 */
const Button: FC<BaseButtonProps> = (props) => {
  const {
    variant = 'outline',
    color = 'primary',
    size = 'md',
    disableUppercaseTransform = false,
    className,
    children,
    ...restProps
  } = props
  return (
    <button
      {...restProps}
      className={clsx(
        'flex items-center justify-center',
        'border border-midnight',
        'transition-colors hover:cws-bg--color-seafoam active:bg-medium-grey disabled:cws-bg--color-seafoam disabled:border-medium-grey',
        // 'focus:outline-midnight focus:outline-dotted',
        'py-2 px-6',
        'text-base leading-5.5 font-medium',
        !disableUppercaseTransform && 'uppercase',
        // styles['button-base'],
        // styles[`${variant}-${color}`],
        // size !== 'custom' && styles[`size-${size}`],
        // disableUppercaseTransform && styles['no-uppercase'],

        className ? className : 'bg-transparent'
      )}
    >
      {children}
    </button>
  )
}

export default Button
